import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaBell } from 'react-icons/fa';

import CallAPI from '../../api/CallAPI';
import MeetingAPI from '../../api/MeetingAPI';
import LeadAPI from '../../api/LeadAPI';
import Const from '../../util/Constants';
import Util from '../../util/Util';

class BellMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = { calls: null, meetings: null, leadBods: null, leadAnns: null };
    this.models = reactLocalStorage.getObject(Const.Model);
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    this.User = `${Const.Opt}${user}${Const.Opt}`;

    this.callFields = ['model', 'date_time'];
    this.meetingFields = ['model', 'date_time', 'responsible_person'];
    this.leadFields = ['firstname', 'lastname', 'phone'];

    const today = new Date();
    today.setHours(23);
    today.setMinutes(59);
    today.setSeconds(59);
    today.setMilliseconds(999);
    this.pagination = { currentPage: 1, pageCount: 1, perPage: 10 };
    const filters = [];
    filters.push({
      field: 'responsible_person', type: 'multiselect~user',
      condition: 'equals', value: this.User
    });
    filters.push({
      field: 'date_time', type: 'datetime',
      condition: 'end-with', value: `~${Util.dateToServerDateTime(today)}`
    });
    filters.push({ field: 'complete', type: 'complete', condition: 'in', value: '' });
    this.list = { filters, pagination: this.pagination };

    this.showCall = Util.isAllow(this.models.call.permission, Const.PermView);
    this.showMeeting = Util.isAllow(this.models.meeting.permission, Const.PermView);
    this.showBirthday = this.models.lead.fields.dob.visible ? true : false;
    this.showAnniversary = this.models.lead.fields.anniversary.visible ? true : false;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(this.props.changed !== props.changed) {
      this.getCount();
    }
  }

  componentDidMount() {
    this.getCount();
    const interval = 10 * 60 * 1000;
    this.interval = setInterval(this.getCount, interval);
  }

  getCount = () => {
    if (this.showCall) { this.loadCalls(); }
    if (this.showMeeting) { this.loadMeetings(); }
    if (this.showBirthday) { this.loadLeadBirthdays(); }
    if (this.showAnniversary) { this.loadLeadAnniversary(); }
  }

  loadCalls = () => CallAPI.count(this.list, this.callsReceived);
  callsReceived = res => this.setState({ ...this.state, calls: res.count });

  loadMeetings = () => MeetingAPI.count(this.list, this.meetingReceived);
  meetingReceived = res => this.setState({ ...this.state, meetings: res.count });

  loadLeadBirthdays = () => {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let value = `${Util.dateToServerDateTime(today)}~`;
    today.setHours(23);
    today.setMinutes(59);
    today.setSeconds(59);
    today.setMilliseconds(999);
    value += `${Util.dateToServerDateTime(today)}`;

    const filters = [];
    if (Util.isAllow(this.models.lead.permission, Const.PermRestricAcc)) {
      filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User
      });
    }
    filters.push({ field: 'dob', type: 'date', condition: 'today', value });
    const list = { ...this.list, filters };
    LeadAPI.count(list, this.leadBirthdays);
  }
  leadBirthdays = res => this.setState({ ...this.state, leadBods: res.count });

  loadLeadAnniversary = () => {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let value = `${Util.dateToServerDateTime(today)}~`;
    today.setHours(23);
    today.setMinutes(59);
    today.setSeconds(59);
    today.setMilliseconds(999);
    value += `${Util.dateToServerDateTime(today)}`;

    const filters = [];
    if (Util.isAllow(this.models.lead.permission, Const.PermRestricAcc)) {
      filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'equals', value: this.User
      });
    }
    filters.push({ field: 'anniversary', type: 'date', condition: 'today', value });
    const list = { ...this.list, filters };
    LeadAPI.count(list, this.leadAnniversary);
  }
  leadAnniversary = res => this.setState({ ...this.state, leadAnns: res.count });

  render() {
    const count = (this.state.calls ? this.state.calls : 0)
      + (this.state.meetings ? this.state.meetings : 0)
      + (this.state.leadBods ? this.state.leadBods : 0)
      + (this.state.leadAnns ? this.state.leadAnns : 0);
    return (
      <div className='top-left-menu'>
        <Link to='/notifications' className='text-white' title="Notifications"
          style={{ textDecoration: 'none' }}>
          <FaBell />
          <span className='badge menu-b badge-danger badge-mini rounded-circle'>
            {count}
          </span>
        </Link>
      </div>
    );
  }
}
export default BellMenu;